module.exports = require("@mui/material/Badge");